import type { QueryClient } from "@tanstack/react-query";

import { getNavbarQueryOptions, type Navbar } from "../services/user";

import { getWorkspaceSidebar, type WorkspaceSidebar } from "./sidebar";
import { getWorkspaceUser, type WorkspaceUser } from "./user";
import {
  getWorkspaceWebapps,
  type Webapps,
  type WorkspaceWebapps,
} from "./webapps";

type Workspace = {
  navbar: Navbar;
  user: WorkspaceUser;
  sidebar: WorkspaceSidebar;
  webapps: WorkspaceWebapps;
};

export async function getWorkspace(
  queryClient: QueryClient,
  webapp?: Webapps,
): Promise<Workspace> {
  const options = getNavbarQueryOptions();
  const navbar = await queryClient.ensureQueryData(options);

  const user = getWorkspaceUser(navbar);
  const sidebar = getWorkspaceSidebar(navbar);
  const webapps = getWorkspaceWebapps({
    sidebar,
    fromService: webapp,
  });

  return {
    user,
    navbar,
    sidebar,
    webapps,
  };
}
